import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HdmuiAvatarComponent, HdmuiKeyValueComponent } from '@heidelberg/hdmui-angular';
import { TranslateModule } from '@ngx-translate/core';

import { ActivityByIdPipe } from '@data-terminal/feature-workstation-details/pipes/activity-by-id.pipe';
import { Employee } from '@data-terminal/shared-models/employee';
import { Activity } from '@data-terminal/shared-models/operation';
import { TimeModeDisplayType } from '@data-terminal/shared-models/time-mode-display-type';
import { TimeModeEntry } from '@data-terminal/shared-models/time-mode-entry.interface';
import { TranslateActivityNamePipe } from '@data-terminal/ui-presentational/pipes';
import { TimeFormatterPipeModule } from '@data-terminal/utils/pipes';

@Component({
    selector: 'data-terminal-time-mode-entry-card-content',
    templateUrl: './time-mode-entry-card-content.component.html',
    styleUrls: ['./time-mode-entry-card-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        TranslateModule,
        HdmuiKeyValueComponent,
        HdmuiAvatarComponent,
        MatTooltipModule,
        ActivityByIdPipe,
        TranslateActivityNamePipe,
        TimeFormatterPipeModule,
    ],
})
export class TimeModeEntryCardContentComponent {
    public entry = input.required<TimeModeEntry>();
    public activities = input<Activity[]>([]);
    public mode = input<TimeModeDisplayType>(TimeModeDisplayType.CARDS);
    public height = input<number | undefined>(undefined);
    public lowCardThresholdPx = input<number>(60);
    public valuesOnly = input<boolean>(false);
    public assistants = input<Employee[]>([]);

    public readonly DisplayType = TimeModeDisplayType;

    public readonly cardHeaderClasses = computed(() => ({
        'hdmui-my-3': this.mode() === TimeModeDisplayType.CARDS,
        'hdmui-my-0': this.mode() === TimeModeDisplayType.TIMELINE,
    }));
    public get isLowHeight(): boolean {
        return this.mode() === TimeModeDisplayType.TIMELINE && (this.height() ?? 0) <= this.lowCardThresholdPx();
    }

    public get showJobId(): boolean {
        return this.mode() === TimeModeDisplayType.CARDS || (this.height() ?? 0) > this.lowCardThresholdPx();
    }
}
